<div
  #widgetRoot
  class="hospitality-chat-widget"
  [class.open]="isOpen"
  [class.mobile]="isMobile"
  [style.--theme-color]="themeColor"
>
  <button
    *ngIf="!hideBubble"
    #bubble
    class="chat-bubble"
    type="button"
    (click)="onBubbleClick($event)"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerCancel()"
    [class.mobile]="isMobile"
    [style.top.px]="isMobile ? mobilePosition.y : null"
    [style.left.px]="isMobile ? mobilePosition.x : null"
  >
    <span class="bubble-icon">🤖</span>
    <span class="bubble-label">{{ 'HOSPITALITY_CHAT.BUBBLE_LABEL' | translate }}</span>
  </button>

  <section
    class="chat-panel"
    *ngIf="isOpen"
    [class.mobile]="isMobile"
    (click)="$event.stopPropagation()"
  >
    <header class="chat-header">
      <div class="header-title">
        <span class="header-icon">✨</span>
        <span>{{ 'HOSPITALITY_CHAT.HEADER_TITLE' | translate }}</span>
      </div>
      <button type="button" class="close-btn" (click)="closeWidget()" aria-label="Close">
        <i nz-icon nzType="close"></i>
      </button>
    </header>

    <div class="chat-body" #scrollContainer>
      <div
        class="chat-message"
        *ngFor="let message of messages; trackBy: trackByMessageId"
        [class.from-user]="message.role === 'user'"
        [class.from-assistant]="message.role === 'assistant'"
      >
        <div class="message-bubble">
          <ng-container [ngSwitch]="message.role">
            <p *ngSwitchCase="'user'">{{ message.content }}</p>
            <markdown
              *ngSwitchCase="'assistant'"
              class="assistant-markdown"
              [data]="message.content"
            ></markdown>
            <p *ngSwitchDefault>{{ message.content }}</p>
          </ng-container>
        </div>
        <div class="vote-row" *ngIf="message.role === 'assistant' && message.turnId">
          <button
            type="button"
            class="vote-btn"
            [class.active]="message.userVote === 'up'"
            (click)="voteUp(message)"
            [disabled]="!!message.voteLoading"
            [attr.aria-label]="'HOSPITALITY_CHAT.VOTE_HELPFUL' | translate"
            [attr.title]="'HOSPITALITY_CHAT.VOTE_HELPFUL' | translate"
          >
            <i nz-icon nzType="like"></i>
          </button>
          <button
            type="button"
            class="vote-btn"
            [class.active]="message.userVote === 'down'"
            (click)="onDownvoteButtonClick(message)"
            [disabled]="!!message.voteLoading"
            [attr.aria-label]="'HOSPITALITY_CHAT.VOTE_NOT_HELPFUL' | translate"
            [attr.title]="'HOSPITALITY_CHAT.VOTE_NOT_HELPFUL' | translate"
          >
            <i nz-icon nzType="dislike"></i>
          </button>
        </div>
        <div class="downvote-dialog" *ngIf="isDownvoteDialogOpen(message)">
          <p class="downvote-title">{{ 'HOSPITALITY_CHAT.DOWNVOTE_PROMPT' | translate }}</p>
          <div class="reason-chips">
            <button
              type="button"
              class="reason-chip"
              *ngFor="let reason of downvoteReasons"
              [class.selected]="downvoteDialogs[message.turnId!]?.selectedReason === reason.key"
              (click)="selectDownvoteReason(message.turnId!, reason.key)"
              [disabled]="!!message.voteLoading"
            >
              {{ reason.translationKey | translate }}
            </button>
          </div>
          <textarea
            *ngIf="isOtherReasonSelected(message)"
            class="other-reason-input"
            rows="1"
            [placeholder]="'HOSPITALITY_CHAT.DOWNVOTE_OTHER_PLACEHOLDER' | translate"
            [ngModel]="downvoteDialogs[message.turnId!]?.customReason || ''"
            (ngModelChange)="updateDownvoteCustomReason(message.turnId!, $event)"
            [disabled]="!!message.voteLoading"
          ></textarea>
          <div class="dialog-actions">
            <button
              type="button"
              class="skip-btn"
              (click)="skipDownvote(message)"
              [disabled]="!!message.voteLoading"
            >
              {{ 'HOSPITALITY_CHAT.DOWNVOTE_SKIP' | translate }}
            </button>
            <button
              type="button"
              class="submit-btn"
              (click)="submitDownvote(message)"
              [disabled]="!!message.voteLoading || !canSubmitDownvote(message)"
            >
              {{ 'HOSPITALITY_CHAT.DOWNVOTE_SUBMIT' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="error-banner" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <footer class="chat-footer">
      <textarea
        [(ngModel)]="inputValue"
        rows="2"
        class="chat-input"
        [placeholder]="'HOSPITALITY_CHAT.INPUT_PLACEHOLDER' | translate"
        (keydown)="onInputKeydown($event)"
      ></textarea>
      <button
        type="button"
        class="send-btn"
        (click)="sendQuestion()"
        [disabled]="!inputValue.trim() || loading"
      >
        {{ loading ? ('HOSPITALITY_CHAT.LOADING' | translate) : ('HOSPITALITY_CHAT.SEND' | translate) }}
      </button>
    </footer>

    <div class="loading-overlay" *ngIf="loading">
      <nz-spin nzSimple></nz-spin>
    </div>
  </section>
</div>
